import {
  Badge,
  Chip,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material'
import type { Schedule } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import dateUtil from 'src/exShared/util/date'
import { useLimitedFeatureAvailability } from 'src/features/featureAvailability/useLimitedFeatureAvailability'
import type { RootState } from 'src/state/store'
import ActionButtons from './ActionButtons'
import CheckboxRow from './CheckboxRow'
import type { TChooseScheduleUUIDsState } from './ScheduleListContent'

export type TBaseColumnProps<
  T extends Record<string, unknown> = Record<string, unknown>,
> = { schedule: Schedule } & T

const isActiveBadge = (isActive?: boolean) => {
  if (isActive)
    return (
      <Stack direction="row" spacing={1} alignItems="center">
        <Badge color="success" variant="dot" />
        <Typography variant="body2" color="success.main" fontWeight="bold">
          アクティブ
        </Typography>
      </Stack>
    )
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Badge color="secondary" variant="dot" />
      <Typography variant="body2" color="text.secondary">
        停止中
      </Typography>
    </Stack>
  )
}

const ScheduleListRow: FC<
  TChooseScheduleUUIDsState & {
    schedule: Schedule
  }
> = ({ schedule, chooseScheduleUUIDsState }) => {
  const { isFeatureAvailable } = useLimitedFeatureAvailability()

  const templates = useSelector(
    (state: RootState) => state.schedulesState.schedulesTemplates.templates,
  )

  const firstScheduleTemplate = (schedule.templates ?? [])[0]
  const isAudit = templates.find(
    item => item.id === (firstScheduleTemplate?.id ?? 0),
  )?.isAudit

  return (
    <TableRow
      hover
      component={Link}
      to={`/schedules/${schedule.uuid}`}
      key={schedule.id}
      sx={{
        textDecoration: 'none',
      }}
    >
      <CheckboxRow
        schedule={schedule}
        chooseScheduleUUIDsState={chooseScheduleUUIDsState}
      />
      <TableCell size="small" sx={{ wordBreak: 'break-all' }}>
        {schedule.name}
        {isFeatureAvailable('improves') && isAudit && (
          <Chip
            label="カイゼン"
            color="primary"
            variant="pale"
            size="small"
            sx={{ ml: 1 }}
          />
        )}
      </TableCell>
      <TableCell size="small" sx={{ wordBreak: 'break-all' }}>
        {firstScheduleTemplate?.name ?? '【削除済み】'}
        {isFeatureAvailable('improves') && isAudit && (
          <Chip
            label="カイゼン"
            color="primary"
            variant="pale"
            size="small"
            sx={{ ml: 1 }}
          />
        )}
      </TableCell>
      <TableCell size="small">{isActiveBadge(schedule.isActive)}</TableCell>
      <TableCell size="small">
        {dateUtil.formatYYYYMMDD_locale(
          new Date(schedule.startReportDate ?? ''),
        )}
      </TableCell>
      <TableCell size="small">
        {schedule.endReportDate &&
          dateUtil.formatYYYYMMDD_locale(
            new Date(schedule.endReportDate ?? ''),
          )}
      </TableCell>
      <TableCell size="small">
        <ActionButtons schedule={schedule} />
      </TableCell>
    </TableRow>
  )
}

export default ScheduleListRow
